import {
  registerOrganizationResetHandler,
  registerSessionResetHandler,
} from '../../shared/ports/sessionResetPort';
import { useEmployeesStore, resetEmployeesLoadState } from '../store/useEmployeesStore';

const resetEmployeesStore = () => {
  resetEmployeesLoadState();
  useEmployeesStore.getState().setEmployees([]);
};

registerSessionResetHandler(resetEmployeesStore);

// Org switch cambia de org con el mismo usuario: employees/selfOwner son
// org-scoped y el cache TTL (1h) no debe sobrevivir al cambio.
registerOrganizationResetHandler(resetEmployeesStore);
